import { Box, Stack, Button, Tooltip, Typography, FormControlLabel, Checkbox, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

const fieldLimits = {
    locationCode: 10,
    locationName: 50,
}

export default function MRDLocation(props) {
    const [locationData, setlocationData] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [EditID, setEditID] = useState(null);
    const [formState, setFormState] = useState({
        locationName: '',
        locationCode: '',
    });
    const [EditPopup, setEditPopup] = useState(false);
    let commonDisable = props?.Access?.editAccess
    useEffect(() => {
        getLocationMaster()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getLocationMaster = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.MRD_RACK_GET_POST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setlocationData(response?.data?.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const AddLocationMaster = () => {
        try {
            if (!formState?.locationName || CommonValidation.removeSpace(formState?.locationName) == "") {
                return errorMessage('Please Enter Rack Name');
            }
            let data = {
                rack_name: ((formState?.locationName ?? '').trim()),
                rack_code: formState?.locationCode || '',
                is_active: isActive,
                ...(EditID && { rack_id: EditID })
            }
            setisloader(true)
            RestAPIService.create(data, Serviceurls.MRD_RACK_GET_POST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFormState({
                            locationName: '',
                            locationCode: '',
                        });
                        setIsActive(true)
                        setEditID(null)
                        getLocationMaster()
                        setEditPopup(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    }
                    else if (e?.response?.data?.message === "Rack Number already exist") {
                        errorMessage(e?.response?.data?.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {

        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>

            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = locationData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        locationData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 's_no', headerName: 'S.No', flex: 0.02, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.api.getRowIndex(params.id) + 1}</Typography>)
            },
            {
                field: 'rack_code', headerName: 'MRD Rack Code', flex: 0.4,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.rack_code ? params?.row?.rack_code : '-'}</Box>)

            },
            {
                field: 'rack_name', headerName: 'MRD Rack Name', flex: 0.4,
                renderCell: (params) => (params.row.rack_name ? params.row.rack_name?.length > 70 ?
                    <Tooltip placement="top" title={params.row.rack_name}><Typography fontSize={'0.9vw'}>{params.row.rack_name?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.rack_name}</Typography> : '-')

            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.2, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => {
                                setFormState({
                                    locationName: params.row.rack_name || '',
                                    locationCode: params.row.rack_code || '',
                                });
                                setEditID(params.row.id);
                                setIsActive(params.row.is_active || false);
                            }} />
                        </Stack>
                    </Stack>)

            }] : [])
        ]
        return (
            <Box sx={{ height: '64vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={locationData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const PopupClose = () => {
        setisDelete(false);
        setdeletedID(null)
        setEditPopup(false)
    }

    const deleteLocationMaster = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || [])
            RestAPIService.delete(Serviceurls.MRD_RACK_GET_POST + `?rack_id=${ID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getLocationMaster()
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    autoComplete='off'
                    value={val || ''}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (value === "" || value.length <= (fieldLimits[name] || 50)) {
                            setFormState({
                                ...formState,
                                [name]: e.target.value
                            });
                        }
                    }}
                    variant="outlined"
                />
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '13vh', width: '93vw', alignContent: 'center', backgroundColor: "white", padding: "0.5vw" }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                    {textBox("MRD Rack Code", 'locationCode', formState?.locationCode, '15vw', true)}
                    {textBox("MRD Rack Name*", 'locationName', formState?.locationName, '15vw', false)}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} disabled={!EditID} size='small' />} label={"Active"} />
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            disabled={!commonDisable}
                            onClick={() => {
                                setFormState({
                                    locationName: '',
                                    locationCode: '',
                                });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size='small' variant='contained' disabled={!commonDisable} sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={() => { EditID && !isActive ? setEditPopup(true) : AddLocationMaster() }}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '64vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {EditPopup ?
                <DeletePopup
                    DeletTitle={`This action will affect in rack mapping as well, Are you sure you want to In-Active this item ?`}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={AddLocationMaster.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`This action will affect in rack mapping as well, Are you sure you want to delete this item ?`}
                    DeleteNotify={"This action cannot be undone."}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={deleteLocationMaster.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}